module.exports = __webpack_public_path__ + "static/media/09_1.97fc3fd0.png";